import { Stack } from "@mui-wrapper";
import { Dialog, Text } from "@flat-ui";
import { useAppSelector } from "@store/store-helper";
import { plansCreationStateSelector } from "@store/plan-creation/plan-creation-slice";
import { BaseProduct } from "@utils/product/product-utils-types";

interface Props {
  /** The bundle whose content is listed */
  bundle: BaseProduct;

  /** Function called when the user closes the dialog */
  onClose(): void;
}

/** Lists the features a bundle is made of, so that it is clear what assigning it grants */
export function BundleFeaturesDialog({
  bundle,
  onClose,
}: Props): React.JSX.Element {
  const { featuresOfBundle } = useAppSelector(plansCreationStateSelector);
  const includedFeatures = featuresOfBundle[bundle.identifier] ?? [];

  return (
    <Dialog open title={bundle.name ?? bundle.identifier} onClose={onClose}>
      {includedFeatures.length === 0 ? (
        <Text variant="bodyM">This bundle does not include any feature.</Text>
      ) : (
        <Stack sx={{ gap: 2 }}>
          {includedFeatures.map((feature) => (
            <Stack key={feature.id} sx={{ gap: 0.5 }}>
              <Text variant="labelM">{feature.name}</Text>
              {feature.description && (
                <Text variant="bodyS">{feature.description}</Text>
              )}
            </Stack>
          ))}
        </Stack>
      )}
    </Dialog>
  );
}
